//AppRoutes.js
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import { useEffect } from "react";
import { trackPageView } from "../firebase/analytics";
import Homepage from "../pages/landingpage/Homepage";
import RequireAuth from "../components/RequireAuth";
import Login from "../pages/Login";
import Register from "../pages/Register";
import AdminDashboard from "../pages/AdminDashboard";
import CompanySetup from "../pages/CompanySetup";
import EmployeeDashboard from "../pages/EmployeeDashboard";
import ManageEmployees from "../pages/ManageEmployees";
import ResetPassword from "../pages/ResetPassword";
import Profile from "../pages/Profile";
import TimeManagement from "../pages/TimeManagement";
import SchedulingEmployee from "../pages/SchedulingEmployee";
import SchedulingEmployer from "../pages/SchedulingEmployer";
import EmployerLeave from "../pages/EmployerLeave";
import EmployeeLeave from "../pages/EmployeeLeave";
import EmployeeExpense from "../pages/EmployeeExpenses";
import EmployerAssignedTask from "../pages/EmployerAssignedTask";
import EmployerTaskProgress from "../pages/EmployerTaskProgress";
import EmployerOnboarding from "../pages/EmployerOnboarding";
import EmployeeOnboarding from "../pages/EmployeeOnboarding";
import EmployeeTraining from "../pages/EmployeeTraining";
import EmployerTraining from "../pages/EmployerTraining";
import TrainingTracker from "../components/TrainingTracker";
import PayslipAccess from "../pages/PayslipAccess";
import EmployerTimeTracking from "../pages/EmployerTimeTracking";
import ScreenCapture from "../pages/ScreenCapture";
import CaptureDisplay from "../pages/CaptureDisplay";
import SubmitTicket from "../pages/SubmitTicket";
import EmployeeSubmit from "../pages/EmployeeSubmit";
import SubmittedTicket from "../pages/SubmittedTicket";
import TicketDetails from "../pages/TicketDetails";
import EmployerProfile from "../pages/EmployerProfile";
import Subscription from "../pages/Subscription";
import SubscriptionSuccess from "../pages/SubscriptionSuccess";
import EmployeeDetails from "../pages/EmployeeDetails";
import Analytics from "../pages/Analytics";
import Settings from "../pages/Settings";
import Onboarding from "../pages/Onboarding";
import EmployerExpense from "../pages/EmployeeExpenses";
import Features from "../pages/landingpage/Features";
import AboutUs from "../pages/landingpage/AboutUs";
import Industries from "../pages/landingpage/Industries";
import IndustryDetails from "../pages/landingpage/IndustryDetails";
import BlogPage from "../pages/blog/BlogPage";
import BlogPost from "../pages/blog/BlogPost";
import Prices from "../pages/landingpage/Prices";
import SLASettings from "../pages/SLASettings";
import VerifyEmail from "../pages/VerifyEmail";
import RequireDev from "../components/RequireDev";
import DevBroadcast from "../pages/dev/DevBroadcast";
import Timesheets from "../pages/Timesheets";
import ProfilePending from "../pages/ProfilePending";
import OnboardingGate from "../components/OnboardingGate";
import Privacy from "../pages/Privacy";
import EmployeeTerminated from "../pages/EmployeeTerminated";
import EmployeeInvite from "../pages/EmployeeInvite";
import EmployeeTasks from "../pages/EmployeeTasks";
import RequirePlatformAdmin from "../components/RequirePlatformAdmin";
import PlatformInbox from "../pages/PlatformInbox";

function RouteTracker() {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);

  return null;
}
export default function AppRoutes() {
  return (
    <Router>
      <RouteTracker />
      {/* must be inside Router so useNavigate/useLocation work */}
      <OnboardingGate />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<Homepage />} />
        <Route path="/features" element={<Features />} />
        <Route path="/industries" element={<Industries />} />
        <Route path="/industries/:industryKey" element={<IndustryDetails />} />
        <Route path="/aboutus" element={<AboutUs />} />
        <Route path="/pricing" element={<Prices />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/register" element={<Register />} />
        <Route
          path="/company-setup"
          element={
            <RequireAuth>
              <CompanySetup />
            </RequireAuth>
          }
        />
        <Route
          path="/manage-employees"
          element={
            <RequireAuth>
              <ManageEmployees />
            </RequireAuth>
          }
        />

        <Route
          path="/admin-dashboard"
          element={
            <RequireAuth>
              <AdminDashboard />
            </RequireAuth>
          }
        />
        <Route
          path="/analytics"
          element={
            <RequireAuth>
              <Analytics />
            </RequireAuth>
          }
        />
        <Route
          path="/attendance-tracking"
          element={
            <RequireAuth>
              <EmployerTimeTracking />
            </RequireAuth>
          }
        />
        <Route
          path="/employee-dashboard"
          element={
            <RequireAuth>
              <EmployeeDashboard />
            </RequireAuth>
          }
        />
        <Route
          path="/employee-training"
          element={
            <RequireAuth>
              <EmployeeTraining />
            </RequireAuth>
          }
        />
        <Route
          path="/employer-training"
          element={
            <RequireAuth>
              <EmployerTraining />
            </RequireAuth>
          }
        />

        <Route
          path="/training-tracker"
          element={
            <RequireAuth>
              <TrainingTracker />
            </RequireAuth>
          }
        />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route
          path="/profile"
          element={
            <RequireAuth>
              <Profile />
            </RequireAuth>
          }
        />
        <Route
          path="/time-management"
          element={
            <RequireAuth>
              <TimeManagement />
            </RequireAuth>
          }
        />
        <Route
          path="/employee-submit"
          element={
            <RequireAuth>
              <EmployeeSubmit />
            </RequireAuth>
          }
        />
        <Route
          path="/submit-ticket"
          element={
            <RequireAuth>
              <SubmitTicket />
            </RequireAuth>
          }
        />
        <Route
          path="/submitted-tickets"
          element={
            <RequireAuth>
              <SubmittedTicket />
            </RequireAuth>
          }
        />
        <Route
          path="/employee-scheduling"
          element={
            <RequireAuth>
              <SchedulingEmployee />
            </RequireAuth>
          }
        />
        <Route
          path="/ticket-details/:ticketId"
          element={
            <RequireAuth>
              <TicketDetails />
            </RequireAuth>
          }
        />
        <Route
          path="/employer-scheduling"
          element={
            <RequireAuth>
              <SchedulingEmployer />
            </RequireAuth>
          }
        />
        <Route
          path="/employer-leave"
          element={
            <RequireAuth>
              <EmployerLeave />
            </RequireAuth>
          }
        />
        <Route
          path="/employer-profile"
          element={
            <RequireAuth>
              <EmployerProfile />
            </RequireAuth>
          }
        />
        <Route
          path="/subscription"
          element={
            <RequireAuth>
              <Subscription />
            </RequireAuth>
          }
        />
        <Route
          path="/Settings"
          element={
            <RequireAuth>
              <Settings />
            </RequireAuth>
          }
        />
        <Route
          path="/subscription-success"
          element={
            <RequireAuth>
              <SubscriptionSuccess />
            </RequireAuth>
          }
        />
        <Route
          path="/employee/:employeeId"
          element={
            <RequireAuth>
              <EmployeeDetails />
            </RequireAuth>
          }
        />
        <Route
          path="/sla-settings"
          element={
            <RequireAuth>
              <SLASettings />
            </RequireAuth>
          }
        />
        <Route path="/employee-invite" element={<EmployeeInvite />} />
        <Route
          path="/employee-tasks"
          element={
            <RequireAuth>
              <EmployeeTasks />
            </RequireAuth>
          }
        />
        <Route
          path="/employee-terminated"
          element={
            <RequireAuth>
              <EmployeeTerminated />
            </RequireAuth>
          }
        />
        <Route
          path="/profile-pending"
          element={
            <RequireAuth>
              <ProfilePending />
            </RequireAuth>
          }
        />
        <Route
          path="/employer-assigned-task"
          element={
            <RequireAuth>
              <EmployerAssignedTask />
            </RequireAuth>
          }
        />
        <Route
          path="/employer-task-progress/:employeeId"
          element={
            <RequireAuth>
              <EmployerTaskProgress />
            </RequireAuth>
          }
        />
        <Route
          path="/employee-leave"
          element={
            <RequireAuth>
              <EmployeeLeave />
            </RequireAuth>
          }
        />
        <Route
          path="/verify-email"
          element={
            <RequireAuth>
              <VerifyEmail />
            </RequireAuth>
          }
        />
        <Route
          path="/employee-expense"
          element={
            <RequireAuth>
              <EmployeeExpense />
            </RequireAuth>
          }
        />
        <Route
          path="/employer-expense"
          element={
            <RequireAuth>
              <EmployerExpense />
            </RequireAuth>
          }
        />
        <Route
          path="/screen-capture"
          element={
            <RequireAuth>
              <ScreenCapture />
            </RequireAuth>
          }
        />
        <Route
          path="/capture-display"
          element={
            <RequireAuth>
              <CaptureDisplay />
            </RequireAuth>
          }
        />
        <Route
          path="/employer-onboarding"
          element={
            <RequireAuth>
              <EmployerOnboarding />
            </RequireAuth>
          }
        />
        <Route
          path="/employee-onboarding"
          element={
            <RequireAuth>
              <EmployeeOnboarding />
            </RequireAuth>
          }
        />
        <Route path="/onboarding" element={<Onboarding />} />
        <Route
          path="/payslip-access"
          element={
            <RequireAuth>
              <PayslipAccess />
            </RequireAuth>
          }
        />
        <Route
          path="/employer-timesheets"
          element={
            <RequireAuth>
              <Timesheets />
            </RequireAuth>
          }
        />
        <Route path="/legal" element={<Privacy />} />
        <Route
          path="/dev/announce"
          element={
            <RequireDev>
              <DevBroadcast />
            </RequireDev>
          }
        />
        <Route
          path="/platform-inbox"
          element={
            <RequirePlatformAdmin>
              <PlatformInbox />
            </RequirePlatformAdmin>
          }
        />
        {/* 🔁 Catch-all: unknown routes */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}
